/* eslint-disable import/prefer-default-export,react/forbid-prop-types,react/display-name */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Transaction } from '../TransactionItem';
import { TransactionItemPlaceholder } from '../../../../../../../components/Placeholders';

export const RightSide = forwardRef(
  (
    {
      showSearchInput,
      toggleSearchInput,
      renderSearchInput,
      setCalendarVisible,
      onScroll,
      isLoadingFirstTimeVisible,
      isTransactionsLoading,
      showEmptyList,
      renderFirstLoader,
      setSelectedTransaction,
      wallet,
      renderedList,
      renderEmptyList,
      calendarFilter,
    },
    ref
  ) => (
    <>
      <div className="position-sticky d-block d-md-none top-0 w-100 start-0 px-3 py-2 bg-lighter exchange-mobile rounded-extra">
        <div className="d-flex flex-row align-items-center justify-content-between mx-0">
          {!showSearchInput && (
            <i
              aria-label="search"
              role="button"
              tabIndex={-1}
              onKeyDown={toggleSearchInput}
              className="d-flex icon-search icon-search-other text-white text-f4 border rounded-2 p-1 border-disabled"
              onClick={toggleSearchInput}
            />
          )}
          {showSearchInput && renderSearchInput()}
          <i
            aria-label="calendar"
            role="button"
            tabIndex={-1}
            onKeyDown={() => {}}
            className={`d-flex icon-calendar-navigation ${
              calendarFilter.fromDate || calendarFilter.toDate ? 'text-primary' : 'text-white'
            } text-f4 border rounded-2 p-1 border-disabled`}
            onClick={() => setCalendarVisible(true)}
          />
        </div>
      </div>
      <div
        className="overflow-auto h-65vh pe-0 pe-md-3 account-details-trans-list"
        ref={ref}
        onScroll={onScroll}
        id="scrollableDiv">
        {isLoadingFirstTimeVisible && renderFirstLoader()}
        {showEmptyList && renderEmptyList()}

        {!showEmptyList && !isLoadingFirstTimeVisible && (
          <>
            {Object.keys(renderedList)?.map((date) => (
              <Transaction
                onTransactionSelected={(tx) => setSelectedTransaction(tx)}
                key={date}
                data={renderedList[date]}
                date={date}
                wallet={wallet}
              />
            ))}
            {isTransactionsLoading && <TransactionItemPlaceholder />}
          </>
        )}
      </div>
    </>
  )
);

RightSide.propTypes = {
  showSearchInput: PropTypes.bool.isRequired,
  toggleSearchInput: PropTypes.func.isRequired,
  renderSearchInput: PropTypes.func.isRequired,
  setCalendarVisible: PropTypes.func.isRequired,
  onScroll: PropTypes.func.isRequired,
  isLoadingFirstTimeVisible: PropTypes.bool.isRequired,
  isTransactionsLoading: PropTypes.bool.isRequired,
  showEmptyList: PropTypes.bool.isRequired,
  renderFirstLoader: PropTypes.func.isRequired,
  setSelectedTransaction: PropTypes.func.isRequired,
  renderEmptyList: PropTypes.func.isRequired,
  wallet: PropTypes.func.isRequired,
  renderedList: PropTypes.object.isRequired,
  calendarFilter: PropTypes.object.isRequired,
};
